/**
 * 商城Vuex-mutation
 */
export default {
  // 设置主题颜色
  saveThemeColor(state, themeColor) {
    state.themeColor = themeColor;
  },
  // 设置token
  saveToken(state, token) {
    state.token = token;
  },
  // 保存购物车数量
  saveCarCount(state, carCount) {
    state.carCount = carCount;
  },
  // 保存商品信息
  saveGoodsInfo(state, goodsInfo) {
    state.goodsInfo = goodsInfo;
  },
  // 保存购物车信息
  saveCarInfo(state, carInfo) {
    state.carInfo = carInfo;
  },
  // 保存商品类型
  saveModeType(state, modeType) {
    state.modeType = modeType;
  },
  // 保存商品id
  saveGoodsId(state, goodsId) {
    state.goodsId = goodsId;
  },
  // 保存支付订单信息
  saveOrderInfo(state, orderInfo) {
    state.orderInfo = orderInfo;
  },
  // 保存个人中心type
  savePersonType(state, personType) {
    state.personType = personType;
  },
  // 保存订单类型
  saveOrderType(state, orderType) {
    state.orderType = orderType;
  },
  // 保存订单id
  saveOrderId(state, orderId) {
    state.orderId = orderId;
  },
  // 保存退款商品信息
  saveRefundInfo(state, refundInfo) {
    state.refundInfo = refundInfo;
  },
  // 保存售后订单id
  saveAfterSaleId(state, afterSaleId) {
    state.afterSaleId = afterSaleId;
  },
  // 保存售后订单商品id
  saveAfterSaleGoodsId(state, afterSaleGoodsId) {
    state.afterSaleGoodsId = afterSaleGoodsId;
  },
  // 保存栏目id
  saveColumnId(state, columnId) {
    state.columnId = columnId;
  },
  // 保存栏目分类id
  saveColumnClassId(state, columnClassId) {
    state.columnClassId = columnClassId;
  },
  // 保存栏目title
  saveColumnTitle(state, columnTitle) {
    state.columnTitle = columnTitle;
  },
  // 保存分类id
  saveCategoryId(state, categoryId) {
    state.categoryId = categoryId;
  },
  // 保存分类标题
  saveCategoryTitle(state, categoryTitle) {
    state.categoryTitle = categoryTitle;
  },
  // 保存recommendType
  saveRecommendType(state, recommendType) {
    state.recommendType = recommendType;
  },
  // 保存品牌id
  saveBrandId(state, brandId) {
    state.brandId = brandId;
  },
  // 保存消息type
  saveMessageType(state, messageType) {
    state.messageType = messageType;
  },
  // 保存活动ID
  saveActivityId(state, activityId) {
    state.activityId = activityId;
  },
  // 保存活动分组ID
  saveActivityGroupId(state, activityGroupId) {
    state.activityGroupId = activityGroupId;
  },
  // 保存活动分类标题
  saveActivityTitle(state, activityTitle) {
    state.activityTitle = activityTitle;
  },
  // 保存京东商品类类型
  saveJDGoodsType(state, jdGoodsType) {
    state.jdGoodsType = jdGoodsType;
  },
  // 保存充值金额
  saveRechargeMoney(state, rechargeMoney) {
    state.rechargeMoney = rechargeMoney;
  },
  // 保存取件地址
  savePickUpAddress(state, pickUpAddress) {
    state.pickUpAddress = pickUpAddress;
  },
  // 保存收货地址
  saveAddress(state, shippingAddress) {
    state.shippingAddress = shippingAddress;
  },
  // 保存京东商品列表信息
  saveJDGoodsInfo(state, jdGoodsInfo) {
    state.jdGoodsInfo = jdGoodsInfo;
  },
  // 保存普通商品列表信息
  saveWebGoodsInfo(state, webGoodsInfo) {
    state.webGoodsInfo = webGoodsInfo;
  },
  // 保存蛋糕专区城市ID
  saveCakeCityId(state, cakeCityId) {
    state.cakeCityId = cakeCityId;
  },
  // 保存蛋糕专区城市名字
  saveCakeCityName(state, cakeCityName) {
    state.cakeCityName = cakeCityName;
  },
  // 保存蛋糕专区经纬度
  saveCakeCityLocation(state, cakeCityLocation) {
    state.cakeCityLocation = cakeCityLocation;
  },
  // 保存蛋糕专区商品信息
  saveCakeGoodsInfo(state, cakeGoodsInfo) {
    state.cakeGoodsInfo = cakeGoodsInfo;
  },
  // 保存蛋糕专区列表信息
  saveCakeParams(state, cakeParams) {
    state.cakeParams = cakeParams;
  },
  // 保存配送规则信息
  saveDeliveryRuleInfo(state, deliveryRuleInfo) {
    state.deliveryRuleInfo = deliveryRuleInfo;
  },
  // 保存品牌信息
  saveCakeBrandInfo(state, cakeBrandInfo) {
    state.cakeBrandInfo = cakeBrandInfo;
  },
  // 保存品牌列表信息
  saveCakeBrandGoodsInfo(state, cakeBrandGoodsInfo) {
    state.cakeBrandGoodsInfo = cakeBrandGoodsInfo;
  },
  // 保存蛋糕门店信息
  saveCakeShopInfo(state, cakeShopInfo) {
    state.cakeShopInfo = cakeShopInfo;
  },
  // 保存蛋糕门店商品信息
  saveCakeShopGoodsInfo(state, cakeShopGoodsInfo) {
    state.cakeShopGoodsInfo = cakeShopGoodsInfo;
  },
  // 保存飘窗状态
  saveFloatStatus(state, floatStatus) {
    state.floatStatus = floatStatus;
  },
  // 保存首页分组布局id
  saveLayoutId(state, layoutId) {
    state.layoutId = layoutId;
  },
  // 保存限量特惠搜索信息
  saveSpecialInfo(state, specialInfo) {
    state.specialInfo = specialInfo;
  },
  // 保存限时秒杀搜索信息
  saveSeckillInfo(state, seckillInfo) {
    state.seckillInfo = seckillInfo;
  },
  // 保存电影城市id
  saveMovieCityId(state, movieCityId) {
    state.movieCityId = movieCityId;
  },
  // 保存电影城市名字
  saveMovieCityName(state, movieCityName) {
    state.movieCityName = movieCityName;
  },
  // 保存电影专区信息
  saveMovieInfo(state, movieInfo) {
    state.movieInfo = movieInfo;
  },
  // 保存卡券专区信息
  saveCouponInfo(state, couponInfo) {
    state.couponInfo = couponInfo;
  },
  // 保存评价商品信息
  saveCommentGoodsInfo(state, commentGoodsInfo) {
    state.commentGoodsInfo = commentGoodsInfo;
  },
  // 保存二三类料专区数据
  saveColumnInfo(state, columnInfo) {
    state.columnInfo = columnInfo;
  },
}